import { createAction } from '@reduxjs/toolkit';

import { SetLegendParamPayload } from './types';

export const sortByScore = createAction('tester/sortByScore');

export const setLegendParameter = createAction<SetLegendParamPayload>('tester/setLegendParameter');
